module.exports = __webpack_public_path__ + "static/img/15bg_6.bbfaa6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/15bg_6.png
// module id = 655
// module chunks = 1